import React, { useState } from 'react';
import { toast } from 'react-toastify';
import customAxios from '../../customHook/customAxios';
import { getAuthHeader, getLoggedInUserRoleId } from '../../utils';

const AdminDeleteButton = ({ resource, entryId, label, onDeleted, className = 'btn btn-link p-0 text-danger', children }) => {
    const [deleting, setDeleting] = useState(false);
    if (Number(getLoggedInUserRoleId()) !== 1 || !entryId) return null;

    const handleDelete = async (event) => {
        event.stopPropagation();
        if (!window.confirm(`Delete ${label || 'this entry'}? This cannot be undone.`)) return;
        setDeleting(true);
        try {
            const url = `${process.env.REACT_APP_BASE_URL}/v3/admin/entry/${resource}/${entryId}`;
            const response = await customAxios.delete(url, getAuthHeader());
            if (!response.data?.status) throw new Error(response.data?.error || 'Unable to delete entry.');
            toast.success(response.data.result?.message || 'Entry deleted.');
            if (onDeleted) onDeleted(entryId);
            else window.location.reload();
        } catch (error) {
            toast.error(error.response?.data?.error || error.message || 'Unable to delete entry.');
        } finally {
            setDeleting(false);
        }
    };

    return <button type="button" title={`Delete ${label || 'entry'}`} className={className}
        disabled={deleting} onClick={handleDelete}>
        {children || <><i className={deleting ? 'bx bx-loader bx-spin' : 'bx bx-trash'} /> Delete</>}
    </button>;
};

export default AdminDeleteButton;
